import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';

import { catchError, mapTo, tap } from 'rxjs/operators';
import { config } from '../config';
import { Company } from '../model/company';

import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';
import { ErrorHandlerService } from './errorHandler.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {

  constructor(private http: HttpClient, private router: Router, private handleError: ErrorHandlerService) { }

  getAll(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Companies`)
      .pipe(timeout(Wait),
        tap(resp => {
          return resp;
        }),
        catchError(error => {
          console.error('Error in CompanyService.getAll:', error);
          if (error.message == 'Timeout has occurred') {
            this.handleError.toastTimeout('Demora na comunicação com servidor');
          }
          return of({ items: [], TotalItems: 0 });
        }));
  }

  getDestinations(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Companies/destinations`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getById(id: number): Observable<any> {
    const url = `${config.apiUrl}/Companies/${id}`;
    return this.http.get<any>(url)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }


  add(company: Company): Observable<any> {
    return this.http.post<any>(`${config.apiUrl}/Companies`, company)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }));
  }

  update(company: Company): Observable<any> {
    return this.http.put<any>(`${config.apiUrl}/Companies/${company.id}`, company)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }));
  }

  delete(comapanyId: number): Observable<any> {
    return this.http.delete<any>(`${config.apiUrl}/Companies/${comapanyId}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }));
  }

  getAuthorizations(companyId: number): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Companies/${companyId}/employees`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }));


  }
}
